module.exports = __webpack_public_path__ + "img/40_38_070_780.d0ba0203.jpg";